import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  fieldId: PilotId;
  sectionId: PilotId;
}

export const moveDataFieldToSection = ({ fieldId, sectionId }: Request) => {
  return pilot.put(`document-information-fields/${fieldId}/`, {
    section_id: sectionId,
  });
};
